import React from 'react';
import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { useGcpContext } from './GcpContext';
import { GcpVmTable } from './tables';
import { Box, Typography } from '@mui/material';
import { CRDGCPConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';

// Helper function to group GCP configs by project ID
const groupGcpConfigs = (configs: CRDGCPConfig[]) => {
  const grouped: { [key: string]: CRDGCPConfig[] } = {};

  configs.forEach(config => {
    const key = config.projectId || 'unknown';
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(config);
  });

  return grouped;
};

export const Gcp: React.FC<{ entity: Entity }> = ({ entity }) => {
  const { gcpConfigs } = useGcpContext();
  const groupedConfigs = groupGcpConfigs(gcpConfigs);

  return (
    <>
      {Object.entries(groupedConfigs).map(([projectId, configs]) => (
        <Box key={projectId} sx={{ mb: 4 }}>
          {/* Project ID Header */}
          <Box
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: '#FFEBEE',
              borderRadius: 1,
              border: '1px solid #D32F2F',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                variant="h6"
                sx={{ color: '#D32F2F', fontWeight: 'bold' }}
              >
                Project ID: {projectId}
              </Typography>
            </Box>
          </Box>

          {/* Resource Tables for this project */}
          {configs.map((config, configIdx) => (
            <Box key={configIdx} sx={{ mb: 2 }}>
              {config.resourceTypes?.includes('vm') && (
                <Box sx={{ mb: 2 }}>
                  <GcpVmTable
                    title="Compute Engine VMs"
                    entityRef={stringifyEntityRef(entity)}
                    gcpConfig={config}
                  />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      ))}
    </>
  );
};
